import { takeLatest, all, take } from 'redux-saga/effects'

import { getAvatar } from '../features/avatar/avatarSlice'
import { getBalance } from '../features/balance/balanceSlice'
import { getCollection } from '../features/collection/collectionSlice'
import { getUserCollection } from '../features/collection/userCollectionSlice'
import { getLeaderboard } from '../features/leaderboard/leaderboardSlice'
import { getShopItems } from '../features/shopItems/shopItemsSlice'
import { getEpoch } from '../features/staking/epochSlice'
import { getStakeInfo } from '../features/staking/stakeInfoSlice'
import { getWaxUser, getAnchorUser } from '../features/user/userSlice'
import { getProfile } from '../features/userprofile/profileSlice'
import { loginFlow as anchorLogin } from './handlers/anchorUserHandler'
import { avatarFlow } from './handlers/avatarHandler'
import { balanceFlow } from './handlers/balanceHandler'
import { collectionFlow } from './handlers/collectionHandler'
import { epochDetailsFlow } from './handlers/epochHandler'
import { LeaderboardFlow } from './handlers/leaderboardHandler'
import { profileFlow } from './handlers/profileHandler'
import { shopItemsFlow } from './handlers/shopItemsHandler'
import { stakeInfoFlow } from './handlers/stakeInfoHandler'
import { collectionFlow as userCollectionFlow } from './handlers/userCollectionHandler'
import { loginFlow as waxLogin } from './handlers/waxUserHandler'

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
function* waxUser() {
  yield takeLatest(getWaxUser, waxLogin)
}

function* anchorUser() {
  yield takeLatest(getAnchorUser, anchorLogin)
}

function* collection() {
  yield takeLatest(getCollection, collectionFlow)
}
function* avatar() {
  yield takeLatest(getAvatar, avatarFlow)
}
function* profile() {
  yield takeLatest(getProfile, profileFlow)
}

function* userCollection() {
  yield takeLatest(getUserCollection, userCollectionFlow)
}


function* leaderboard() {
  yield takeLatest(getLeaderboard, LeaderboardFlow)
}

function* epoch() {
  yield takeLatest(getEpoch, epochDetailsFlow)
}
function* stakeInfo() {
  yield takeLatest(getStakeInfo, stakeInfoFlow)
}
function* balance() {
  yield takeLatest(getBalance, balanceFlow)
}

function* shopItems() {
  yield takeLatest(getShopItems, shopItemsFlow)
}

export function* logActions() {
  while (true) {
    const action = yield take('*')
    console.log(action)
  }
}

export function* rootSaga() {
  yield all([
    collection(),
    waxUser(),
    anchorUser(),
    avatar(),
    balance(),
    profile(),
    userCollection(),
    leaderboard(),
    epoch(),
    stakeInfo(),
    shopItems(),
    logActions(),
  ])
}
